import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { TrendingUp, TrendingDown, RefreshCw } from "lucide-react";

export default function FinancialCentre() {
  const [data, setData] = useState({ items: [], as_of: null });
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/kip/markets/financial-centre");
      setData(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="financial-centre-page">
      <div className="flex items-center justify-between">
        <div>
          <div className="eyebrow">Knowledge Intelligence</div>
          <h1 className="font-sans text-3xl">Financial Centre</h1>
          <p className="text-sm text-slate-600 mt-1">Live commodities, FX, and index quotes — sourced from Yahoo Finance.</p>
          {data.as_of && <p className="text-xs text-slate-400 mt-1">As of {data.as_of.slice(0, 19).replace("T", " ")}</p>}
        </div>
        <Button variant="outline" onClick={load} disabled={loading} data-testid="refresh-centre"><RefreshCw className={`h-4 w-4 mr-1 ${loading ? "animate-spin" : ""}`}/>Refresh</Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {(data.items || []).map((it) => {
          const up = (it.change_pct ?? 0) > 0;
          const down = (it.change_pct ?? 0) < 0;
          const TIcon = up ? TrendingUp : TrendingDown;
          return (
            <Card key={it.label} className="p-4" data-testid={`tile-${it.symbol}`}>
              <div className="flex items-center justify-between">
                <div className="text-xs uppercase tracking-wider text-slate-500">{it.label}</div>
                {(up || down) && <TIcon className={`h-4 w-4 ${up ? "text-emerald-600" : "text-red-600"}`}/>}
              </div>
              <div className="mt-2 text-2xl font-mono font-semibold text-slate-900">
                {it.value != null ? `${it.currency === "INR" ? "₹" : "$"}${it.value.toLocaleString("en-IN")}` : "—"}
              </div>
              {it.change_pct != null && (
                <div className={`text-xs mt-1 ${up ? "text-emerald-600" : down ? "text-red-600" : "text-slate-500"}`}>
                  {up ? "+" : ""}{it.change_pct}% ({it.change > 0 ? "+" : ""}{it.change})
                </div>
              )}
              {it.error && <div className="text-[11px] text-red-500 mt-1">{it.error}</div>}
            </Card>
          );
        })}
        {!(data.items || []).length && !loading && (
          <Card className="p-8 text-center text-slate-400 col-span-full">No data — Yahoo Finance may be temporarily unavailable.</Card>
        )}
      </div>
    </div>
  );
}
